//意大利
export default {
    common: {
        notshow: 'Non mostrare oggi',
        unit: 'USDT',
        day: 'Giorno',
        week: 'Settimana',
        save: 'Salva',
        submit: 'Invia',
        confirmtitle: 'Conferma Operazione',
        confirm: 'Conferma',
        reset: 'Ripristina',
        refresh: 'Aggiorna',
        copy: 'Copia',
        copysuccessful: 'Copia Riuscita',
        modify: 'Modifica',
        binding: 'Collega',
        finished: 'Completato',
        canceled: 'Annullato',
        cancel: 'Annulla',
        all: 'Tutto',
        back: 'Indietro',
        loading: 'Caricamento...',
        nomore: 'Tutti i Record',
        errortxt: 'Caricamento Fallito',
        loosing: 'Rilascia per aggiornare...',
        pulling: 'Trascina in basso per aggiornare...',
        nodata: 'Nessun record',
        buy: 'Acquista',
        buyup: 'Compra al Rialzo',
        buydown: 'Compra al Ribasso',
        sell: 'Vendi',
        forserver: 'Contatta Assistenza Clienti',
        total: 'Totale',
        status1: 'In Revisione',
        status2: 'Completato',
        status3: 'Rifiutato',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Bonifico Bancario'
    },
    footer: {
        home: 'Home',
        market: 'Mercato',
        exchange: 'Exchange',
        options: 'Opzioni',
        assets: 'Asset',
        change: 'Trasferimento',
        recharge: 'Deposito',
        withdrawal: 'Prelievo'
    },
    home: {
        menu1: 'Trading Opzioni',
        menu1desc: 'Supporta BTC/USDT ecc',
        menu2: 'Deposito Rapido',
        menu3: 'Prelievo',
        menu4: 'Supporto Online',
        menu5: 'Cambio Rapido',
        menu6: 'Prestiti',
        menu7: 'Mining Staking',
        menu8: 'Pegno',
        menu9: 'Trasferimento Account',
        ranktitle: 'Lista Rialzi',
        name: 'Nome',
        price: 'Ultimo Prezzo',
        risefall: 'Variazione %'
    },
    register: {
        register: 'Registrati',
        login: 'Accedi',
        email: 'Email',
        phone: 'Telefono',
        accountplaceholder: 'Inserisci account',
        emailplaceholder: 'Inserisci email',
        phoneplaceholder: 'Inserisci numero di telefono',
        pwdplaceholder: 'Inserisci password',
        pwdplaceholder1: 'La password deve essere di 6-20 caratteri',
        agepwdplaceholder: 'Conferma password',
        agepwdplaceholder1: 'Le password non coincidono',
        invitecodeplaceholder: 'Inserisci codice invito',
        remember: 'Ricorda password',
        fotget: 'Password dimenticata'
    },
    market: {
        title: 'Mercato',
        all: 'Tutto'
    },
    member: {
        reputation: 'Punteggio Credito',
        identity_authentication: 'Verifica Identità',
        under_review: 'In Revisione',
        certified: 'Verificato',
        awaiting_certification: 'In Attesa di Verifica',
        binding_withdrawal_address: 'Collega Indirizzo Prelievo',
        currently_selected_currency: 'Valuta Corrente',
        withdrawal_address: 'Indirizzo Prelievo',
        sharing_link: 'Il Mio Link di Condivisione',
        my_promotion_code: 'Il Mio Codice Referral',
        promotion_code: 'Codice Referral',
        system_message: 'Messaggio di Sistema',
        night_mode: 'Modalità Notte',
        security_center: 'Centro Sicurezza',
        seted: 'Impostato',
        noset: 'Non Impostato',
        login_password: 'Password di Accesso',
        transaction_password: 'Password Transazioni',
        app_download: 'Scarica App',
        log_out: 'Esci',
        aboutus: 'Introduzione al sito web'
    },
    identity: {
        title: 'Verifica Identità',
        name: 'Nome',
        nameplaceholder: 'Inserisci nome reale',
        uploader: 'Carica Foto ID',
        tip1: 'Carica Fronte ID',
        tip2: 'Carica Retro ID'
    },
    address: {
        title: 'Collega Indirizzo Prelievo',
        bType: 'Valuta Corrente',
        address: 'Indirizzo Prelievo',
        addressplaceholder: 'Inserisci indirizzo prelievo'
    },
    security: {
        title: 'Centro Sicurezza',
        modifypwd: 'Password di Accesso',
        resetlegalpwd: 'Password Transazioni',
        loginpwd: 'Nuova Password di Accesso',
        pwdage: 'Conferma Password',
        loginpwdplaceholder: 'Inserisci password di accesso attuale',
        loginnewpwdplaceholder: 'Inserisci nuova password di accesso',
        moneypwd: 'Inserisci password transazioni',
        pwdageplaceholder: 'Conferma password di nuovo'
    },
    trade: {
        title: 'Trading Exchange',
        price: 'Prezzo',
        num: 'Quantità',
        entrust: 'Ordini Correnti',
        clinch: 'Scambi Completati',
        used: 'Disponibile',
        buyed: 'Acquistabile',
        amount: 'Importo Trading',
        limitprice: 'Prezzo Limite',
        marketprice: 'Prezzo Mercato',
        forprice: 'Scambia al miglior prezzo corrente',
        errorMoney: 'Saldo insufficiente',
        priceerror: 'Inserisci prezzo ordine',
        numerror: 'Inserisci quantità ordine',
        moneyerror: 'Inserisci valore ordine'
    },
    assets: {
        allconvert: 'Valore Totale Asset',
        usenum: 'Disponibile',
        freeze: 'Congelato',
        convert: 'Converti',
        tab1: 'Asset',
        tab11: 'Valore Totale Asset',
        tab12: 'Valore Opzioni',
        tab13: 'Valore Fondi',
        tab14: 'Valore Quant',
        tab2: 'Opzioni',
        tab21: 'Account Opzioni',
        tab3: 'Fondi',
        tab31: 'Account Fondi',
        tab4: 'Quant',
        tab41: 'Account Quant',
        tbhead1: 'Record Finanziari',
        tbhead2: 'Record Prelievi',
        tbhead3: 'Record Depositi',
        tbhead4: 'Record Trasferimenti',
        rcdnum: 'Importo',
        rcd: 'Record',
        rcdtime: 'Ora',
        rcdstatus: 'Stato',
        rcddesc: 'Note',
        rcdaddress: 'Indirizzo Deposito'
    },
    change: {
        title: 'Trasferimento',
        from: 'Da {name}',
        to: 'A {name}',
        frmtitle: 'Importo Trasferimento',
        inputplaceholder: 'Inserisci importo trasferimento',
        btntxt: 'Trasferisci'
    },
    recharge: {
        title: 'Deposito',
        bType: 'Valuta Corrente',
        address: 'Indirizzo Deposito',
        token: 'Prova di Pagamento',
        tokenplaceholder: 'Carica prova di pagamento',
        num: 'Importo Deposito',
        numplaceholder: 'Inserisci importo',
        btn: 'Invia per Revisione',
        bankname: 'Nome Banca',
        bankno: 'Numero Banca',
        accountname: 'Nome Account',
        bankaddress: 'Indirizzo Banca',
        bankcode: 'Codice Bonifico Bancario',
        companyaddress: 'Indirizzo Azienda'
    },
    withdrawal: {
        title: 'Prelievo',
        frmtitle1: 'Importo',
        frmplaceholder1: 'Importo prelievo tra {min} - {max}',
        frmtitle2: 'Password Transazioni',
        frmplaceholder2: 'Inserisci password transazioni',
        getnum: 'Importo Ricevuto',
        fee: 'Commissione',
        btn: 'Preleva'
    },
    exchangeb: {
        title: 'Cambio',
        account: 'Account',
        btn: 'Cambia',
        numerror: 'Inserisci importo cambio'
    },
    option: {
        title: 'Opzioni',
        typetitle: 'Contratto Secondi',
        listtitle: 'Posizioni',
        kline: 'Grafico K',
        high: 'Alto',
        low: 'Basso',
        nums: 'Vol 24H',
        time: 'Tempo',
        transaction: 'Modalità Trading',
        quantity: 'Dimensione Posizione',
        quantityerror: 'Inserisci dimensione posizione',
        times: 'Orario Apertura',
        times1: 'Tempo di liquidazione',
        account: 'Saldo Account',
        buyup: 'Compra al Rialzo',
        buydown: 'Compra al Ribasso',
        tab1: 'Lista Posizioni',
        tab2: 'Storico Ordini',
        num: 'Importo',
        price1: 'Prezzo Acquisto',
        price2: 'Prezzo Liquidazione',
        profitandloss: 'P/L Stimato',
        profitandloss1: 'P/L',
        countdown: 'Conto alla Rovescia',
        waitfinish: 'In Attesa Liquidazione',
        finishing: 'Liquidazione in corso...',
        finished: 'Liquidato',
        order_price: 'Prezzo Corrente',
        order_cycle: 'Periodo',
        order_type: 'Tipo',
        order_money: 'Importo',
        order_time: 'Apertura',
        order_get: 'Profitto',
        order_btn: 'Continua Trading'
    },
    tradelst: {
        title: 'I Miei Ordini',
        tab1: 'Ordini',
        tab2: 'Completati',
        tab3: 'Annullati',
        usdtnum: ''
    },
    loans: {
        repayment: 'Rimborso',
        title: 'Prestiti',
        order_tab: 'Ordini Prestito',
        pro_tab: 'Prodotti Prestito',
        Institution: 'Istituto di Credito',
        Amount: 'Importo',
        DailyInterest: 'Tasso Interesse Giornaliero',
        RepaymentPeriod: 'Periodo Rimborso',
        Application: 'Richiedi Prestito',
        orderno: 'N. Ordine',
        AllInterest: 'Interesse Totale',
        RepaymentDate: 'Data Rimborso',
        RepaymentMethod: 'Metodo Rimborso',
        Onetime: 'Una tantum',
        Expected_loan_amount: 'Importo Prestito Previsto',
        Expected_loan_amounterror: 'Importo prestito tra {min} - {max}',
        imgplaceholdr: 'Prestito Credito (Assicurati che le immagini siano chiare)',
        icon1: 'Carica Fronte ID',
        icon2: 'Carica Retro ID',
        icon3: 'Carica ID in Mano',
        status1: 'In Richiesta',
        status2: 'Approvato',
        status3: 'Rifiutato'
    },
    lockming: {
        title: 'Mining Staking',
        order_tab: 'Ordini Mining',
        pro_tab: 'Mercato Mining',
        locknum: 'Importo Min Staking',
        getforday: 'Rendimento/Giorni',
        days: 'Giorni',
        estimation: 'Guadagni Stimati',
        real: 'Guadagnato',
        balance: 'Saldo Wallet',
        nums: 'Importo Staking',
        tolockming: 'Stake',
        stime: 'Ora Inizio',
        etime: 'Ora Fine'
    },
    transfer: {
        title: 'Trasferimento Account',
        searchtxt: 'Inserisci account destinatario',
        ReceivingAccount: 'Info Account Destinatario',
        toaccount: 'Account',
        confirmtxt: 'Clicca per confermare account destinatario',
        confirmedtxt: 'Account destinatario confermato',
        numtxt: 'Importo Trasferimento',
        numerror: 'Inserisci importo trasferimento',
        fee: 'Nessuna commissione per trasferimenti interni',
        ArrivalTime: 'Tempo di Arrivo',
        Immediately: 'Immediato',
        realnum: 'Importo Effettivo di Arrivo',
        btn: 'Conferma Trasferimento',
        transfering: 'Trasferimento in corso',
        orderNo: 'N. Ordine',
        stime: 'Ora Trasferimento',
        etime: 'Ora Arrivo',
        receiving: 'Account Destinatario',
        type: 'Valuta',
        num: 'Importo Trasferimento',
        arrivalnum: 'Importo Ricevuto'
    },
    staking: {
        title: 'Staking',
        record: 'Record',
        getforyear: 'Rendimento Annuo Stimato',
        time: 'Periodo Investimento',
        snum: 'Investimento Min',
        snumerror: 'Inserisci importo investimento',
        snumerror1: 'Investimento min non inferiore a {num}',
        join: 'Partecipa Ora',
        opentime: 'Ora Apertura',
        money: 'Importo Investimento',
        days: 'Periodo',
        recordget: 'Rendimento Annuo',
        gets: 'Guadagni',
        stime: 'Data Inizio',
        etiem: 'Data Fine',
        redeemStaking: 'Riscatta',
        status0: 'Staking',
        status1: 'Ordine Terminato',
        status2: 'Ordine Riscattato'
    },
    bank:{
        title: 'Collega Carta Bancaria',  // 符合Bankitalia支付服务命名规范
        bankName: 'Nome Banca',  // 意大利银行注册名录认证
        bankNameError: 'Inserisci il nome della banca',  // 强制输入字段规范
        usrName: 'Titolare della Carta',  // 根据DL 231/2007反洗钱条款
        usrNameError: 'Inserire il nome del titolare',  // 实名验证要求
        cardCode: 'Numero Carta',  // 符合CBI信用卡格式标准
        cardCodeError: 'Inserisci il numero della carta',  // 支付网关验证
        towallet: 'Prelievo a Wallet',  // 意大利央行虚拟货币服务条款
        tobank: 'Prelievo a Conto Bancario',  // SEPA转账规范
        sendcode: 'Invia Codice di Verifica',  // PSD2双重认证要求
        sended: 'Reinvia tra {num} secondi',  // 符合UNI EN 28601时间格式
        verify_code: 'Inserisci codice email'  // GDPR数据保护规范
      }
      
}
